import { Component, OnInit, Input, EventEmitter, Output, ElementRef } from '@angular/core';

@Component({
  selector: 'app-step-three-slider',
  templateUrl: './step-three-slider.component.html',
  styleUrls: ['./step-three-slider.component.scss'],
})
export class StepThreeSliderComponent implements OnInit {
  @Input() max: number;
  @Input() min: number;
  @Input() value: number;
  @Output() valueChange = new EventEmitter<number>();
  @Input() step: number;
  @Input() selectId: string;

  constructor(private host: ElementRef) {}

  ngOnInit() {
    (this.host.nativeElement as Element).id = this.selectId;
  }

  updateValue(event: number) {
    this.valueChange.emit(event);
  }
}
